/**
 * IE-safe method to check if element is instanceof HTMLPictureElement
 * because `HTMLPictureElement` does not exist in IE
 *
 * @param el
 */
export const isPictureElement = (el: Element | null): el is HTMLPictureElement => {
    return el !== null && el.nodeName === "PICTURE";
};



// WEBPACK FOOTER //
// ./components/lazy-image/is-picture-element.ts